import FaqIndex from '../components/Faq/Index'
import FaqDetail from '../components/Faq/Detail'
import FaqSearch from '../components/Faq/Search'
import FaqIndexByCategory from '../components/Faq/IndexByCategory'

export default [
  {
    path: '/client/faqs',
    name: 'faq',
    component: FaqIndex,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/faqs/search',
    name: 'faq-search',
    component: FaqSearch,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/faqs/:id',
    name: 'faq-detail',
    component: FaqDetail,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/faqs/category/:id',
    name: 'faqs-by-category',
    component: FaqIndexByCategory,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/static/faqs',
    name: 'static-faq',
    component: FaqIndex,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/static/faqs/search',
    name: 'static-faq-search',
    component: FaqSearch,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/static/faqs/:id',
    name: 'static-faq-detail',
    component: FaqDetail,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
  {
    path: '/client/static/faqs/category/:id',
    name: 'static-faqs-by-category',
    component: FaqIndexByCategory,
    props: true,
    meta: {
      sideMenuId: 'faq',
    },
  },
]
